module.exports = __webpack_public_path__ + "static/media/get_bg.de32827c.jpg";